/* Nomination koleksiyon filtre çubuğu - Veritas Dijital */
(function () {
  'use strict';
  if (window.__nmFiltersBound) return;
  window.__nmFiltersBound = true;

  var groupsOpen = false;

  function closeDropdowns(except) {
    document.querySelectorAll('.nm-fb [data-nm-dd]').forEach(function (dd) {
      if (dd === except) return;
      var btn = dd.querySelector('[data-nm-dd-toggle]');
      var panel = dd.querySelector('.nm-fb__panel');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
  }

  function setGroups(form, open) {
    var groups = form.querySelector('[data-nm-fb-groups]');
    var toggle = form.querySelector('[data-nm-fb-toggle]');
    if (!groups || !toggle) return;
    groupsOpen = open;
    groups.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('nm-fb-drawer-open', open && window.matchMedia('(max-width: 959px)').matches);
  }

  function render(url) {
    var wrap = document.querySelector('.nm-collection[data-section-id]');
    if (!wrap) { window.location.href = url; return; }
    var sectionId = wrap.dataset.sectionId;
    var fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set('section_id', sectionId);
    wrap.classList.add('is-loading');
    fetch(fetchUrl.toString())
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshForm = doc.querySelector('[data-nm-filter-form]');
        var form = wrap.querySelector('[data-nm-filter-form]');
        if (freshForm && form) form.innerHTML = freshForm.innerHTML;
        var freshGrid = doc.getElementById('ProductGridContainer');
        var grid = document.getElementById('ProductGridContainer');
        if (freshGrid && grid) grid.innerHTML = freshGrid.innerHTML;
        var cleanUrl = new URL(url, window.location.origin);
        cleanUrl.searchParams.delete('section_id');
        window.history.replaceState({}, '', cleanUrl.pathname + cleanUrl.search);
        if (form) setGroups(form, groupsOpen);
        document.dispatchEvent(new CustomEvent('nm:collection:loaded'));
      })
      .catch(function () { window.location.href = url; })
      .finally(function () { wrap.classList.remove('is-loading'); });
  }

  function urlFromForm(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (value === '' || value === null) return;
      params.append(key, value);
    });
    return window.location.pathname + (params.toString() ? '?' + params.toString() : '');
  }

  document.addEventListener('click', function (e) {
    var form = e.target.closest('[data-nm-filter-form]');

    var toggle = e.target.closest('[data-nm-fb-toggle]');
    if (toggle && form) {
      closeDropdowns();
      setGroups(form, toggle.getAttribute('aria-expanded') !== 'true');
      return;
    }

    if (e.target.closest('[data-nm-fb-close]') && form) {
      setGroups(form, false);
      return;
    }

    var ddToggle = e.target.closest('[data-nm-dd-toggle]');
    if (ddToggle && form) {
      var dd = ddToggle.closest('[data-nm-dd]');
      var panel = dd.querySelector('.nm-fb__panel');
      var open = ddToggle.getAttribute('aria-expanded') === 'true';
      closeDropdowns(dd);
      ddToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.hidden = open;
      return;
    }

    var link = e.target.closest('[data-nm-fb-link]');
    if (link) {
      e.preventDefault();
      render(link.href);
      return;
    }

    if (!e.target.closest('[data-nm-dd]')) closeDropdowns();
  });

  var priceTimer;
  document.addEventListener('change', function (e) {
    var form = e.target.closest('[data-nm-filter-form]');
    if (!form) return;
    if (e.target.type === 'number') {
      clearTimeout(priceTimer);
      priceTimer = setTimeout(function () { render(urlFromForm(form)); }, 500);
      return;
    }
    if (e.target.name === 'sort_by') closeDropdowns();
    render(urlFromForm(form));
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-nm-filter-form]');
    if (!form) return;
    e.preventDefault();
    render(urlFromForm(form));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeDropdowns();
    var form = document.querySelector('[data-nm-filter-form]');
    if (form && window.matchMedia('(max-width: 959px)').matches) setGroups(form, false);
  });
})();
